export const environmentCommon = {
	tokenVersion: 2,
};



// WEBPACK FOOTER //
// ./src/environments/environment.common.ts